import CurrencyIcon from "@/components/icons/CurrencyIcon";
import BaseetaIcon from "@/components/icons/payments/BaseetaIcon";
import Link from "next/link";

function truncateToTwoDecimalPlaces(number) {
  const formattedNumber = Number(number?.toFixed(2));
  return formattedNumber.toFixed(2);
}

const BaseetaWidget = ({ price, locale, installments = 36 }) => {
  return (
    <>
      <div className="flex items-center p-3 my-2 border rounded-md">
        <BaseetaIcon className="w-16 md:w-[85px] h-7 object-contain" />
        <p className="flex flex-wrap items-center mx-4 max-sm:text-sm">
          <span>
            {locale === "en" ? (
              <span className="flex items-center gap-1">
                Split your pill with no downpayment and pay{" "}
                <CurrencyIcon className="size-3.5" />
                {truncateToTwoDecimalPlaces((price || 0) / installments) ||
                  ""}{" "}
                over 36 payments
              </span>
            ) : (
              `قسم فاتورتك بدون دفعه اولى بقيمة ${
                truncateToTwoDecimalPlaces((price || 0) / installments) || ""
              } ريال على 36 دفعه`
            )}
          </span>{" "}
          <Link
            href="/baseeta"
            target="_blank"
            className="underline cursor-pointer mx-0.5 font-semibold"
          >
            {locale === "en" ? "Start now with Baseeta" : "إبدا الأن مع بسيطة"}
          </Link>
        </p>
      </div>
    </>
  );
};

export default BaseetaWidget;
